import * as React from "react";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";
import './FieldSettings.css';
import {FieldSettings} from "./FieldSettings";
import {PropertyBase} from "./Properties/PropertyBase";
import {ColorProperty} from "./Properties/ColorProperty";
import {NumberProperty} from "./Properties/NumberProperty";
import {CheckBoxProperty} from "./Properties/CheckBoxProperty";
import {PDFTextField} from "PDFLib/api";
import {DropDownProperty} from "./Properties/DropDownProperty";

export class TextFieldSettings extends FieldSettings {
    GetStyles(): PropertyBase[] {
        return [
            new DropDownProperty(this,'')
                .SetLabel('Alignment')
                .SetOnChangeExternalValue(newValue => {
                    if(newValue=='default')
                        newValue='';
                    this.props.DocumentManager.SelectedPDFField.SetAlignment(newValue==='default'?'':newValue);
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .AddOption('Default','default')
                .AddOption('Left','0')
                .AddOption('Center','1')
                .AddOption('Right','2')
                .SetExternalValue(this.props.DocumentManager.SelectedPDFField.GetAlignment()===''?'default':this.props.DocumentManager.SelectedPDFField.GetAlignment()),
            new ColorProperty(this,'')
                .SetLabel('Border Color')
                .SetOnChangeExternalValue(newValue => {
                    this.props.DocumentManager.SelectedPDFField.SetBorderColor(this.HexToRGB(newValue));
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .SetExternalValue(this.RGBToHex(this.props.DocumentManager.SelectedPDFField.GetBorderColor())),
            new ColorProperty(this,'')
                .SetLabel('Background Color')
                .SetOnChangeExternalValue(newValue => {
                    this.props.DocumentManager.SelectedPDFField.SetBackgroundColor(this.HexToRGB(newValue));
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .SetExternalValue(this.RGBToHex(this.props.DocumentManager.SelectedPDFField.GetBackgroundColor())),
            new NumberProperty(this,'')
                .SetLabel('Font Size')
                .SetOnChangeExternalValue(newValue => {
                    if(isNaN(Number(newValue)))
                        return;
                    if(newValue=='')
                        newValue=0;
                    this.props.DocumentManager.SelectedPDFField.SetFontSize(newValue);
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .SetExternalValue(this.props.DocumentManager.SelectedPDFField.GetFontSize()),
            new CheckBoxProperty(this,'')
                .SetLabel('Read Only')
                .SetOnChangeExternalValue(newValue => {
                    if(newValue)
                        this.props.DocumentManager.SelectedPDFField.Field.enableReadOnly();
                    else
                        this.props.DocumentManager.SelectedPDFField.Field.disableReadOnly();
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .SetExternalValue(this.props.DocumentManager.SelectedPDFField.Field.isReadOnly()),
            new CheckBoxProperty(this,'')
                .SetLabel('Multiline')
                .SetOnChangeExternalValue(newValue => {
                    if(newValue)
                        (this.props.DocumentManager.SelectedPDFField.Field as PDFTextField).enableMultiline();
                    else
                        (this.props.DocumentManager.SelectedPDFField.Field as PDFTextField).disableMultiline();
                    this.props.DocumentManager.RefreshDocument();
                    this.Refresh();
                })
                .SetExternalValue((this.props.DocumentManager.SelectedPDFField.Field as PDFTextField).isMultiline())

        ]
    }


    public HexToRGB(hex:string):number[]
    {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? [
             parseInt(result[1], 16)/255,
             parseInt(result[2], 16)/255,
             parseInt(result[3], 16)/255
        ] : null;
    }

    public RGBToHex(colors:any[])
    {
        if(colors==null||colors.length!=3)
            return '#000';
        return "#" + ((1 << 24) + (colors[0]*255 << 16) + (colors[1]*255 << 8) + colors[2]*255).toString(16).slice(1);

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldSettingsProps {
    DocumentManager:DocumentManager;
}

interface FieldSettingsState {

}

//#endregion "My Region"